import { useTranslation } from 'react-i18next'

import { CalendarBlankIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { trackingTypes } from '@/LabelTrackingPage/constants'

import * as Styles from './styles'

const DeliveryEta = ({ date, type, timezone }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()

  const getDateText = date => {
    const format = new Intl.DateTimeFormat(i18n.language, {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
      weekday: 'long',
      timeZone: timezone || undefined,
    })
    return format.format(new Date(date))
  }

  if (![trackingTypes.shipment, trackingTypes.fulfillment].includes(type) || !date) return null

  return (
    <Styles.Container>
      <CalendarBlankIcon size={32} color={theme.colors.blue.tone700} />
      <Styles.DateContainer>
        <Text type="allCapsS" color={theme.colors.grey.tone500} customStyles={{ textTransform: 'uppercase' }}>
          {t('Entrega estimada')}
        </Text>
        <Text type="bodyMBold" color={theme.colors.blue.tone700}>
          {getDateText(date)}
        </Text>
      </Styles.DateContainer>
    </Styles.Container>
  )
}

export default DeliveryEta
